import { Injectable } from "@angular/core";
import { Comments } from "@common/interfaces/comment";
import { ID } from "@common/interfaces/id";
import { QueryEntity, QueryConfig, Order } from "@datorama/akita";
import { Observable } from "rxjs";
import { CommentState, CommentStore } from "./comment.store";
import { ascSort, sortByCreatedAt } from "@ep-om/utils/sort";

@Injectable({
  providedIn: 'root'
})
@QueryConfig({
  sortBy: (a: { createdAt: string }, b: { createdAt: string }) => sortByCreatedAt(a, b)(ascSort)
})
export class CommentQuery extends QueryEntity<CommentState> {
  all$ = this.select();

  constructor(protected store: CommentStore) {
    super(store);
  }

  public selectByIssueId$(issueId: ID): Observable<Comments[]> {
    return this.selectAll({
      filterBy: [
        comment => comment.issueId === issueId
      ]
    })
  }

  public selectByCopyOf$(commentId: ID): Observable<Comments[]> {
    return this.selectAll({
      filterBy: [
        comment => comment.copyOf === commentId
      ]
    })
  }

  public getByIssueId(issueId: ID): Comments[] {
    return this.getAll({
      filterBy: [
        comment => comment.issueId === issueId
      ]
    });
  }

  public getByCopyOf(commentId: ID): Comments[] {
    return this.getAll({
      filterBy: [
        comment => comment.copyOf === commentId
      ]
    });
  }
}
